// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cv-4";
export var closeButton = "_cv-6";
export var dismissButton = "_cv-3";
export var editImageWithAiContainer = "_cv-8";
export var imageUploadWrapper = "_cv-7";
export var misspelledWord = "_cv-5";
export var spellCheckContainer = "_cv-2";
export var spin = "_cv-1";
export var spinning = "_cv-0";